var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("list-item", {
    attrs: {
      booking: _vm.booking,
      link: {
        name: "requests.show",
        params: { id: _vm.booking.id, draft: this.bookingIsDraft },
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "pill",
          fn: function () {
            return [
              _vm.$userIsTalent || _vm.$userIsManager
                ? _c(
                    "div",
                    { staticClass: "inline-flex" },
                    [
                      _vm.talentHasAppliedForBooking
                        ? _c(
                            "span",
                            { staticClass: "label label-success" },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm.$declineModuleEnabled
                                      ? _vm.$t("Applied")
                                      : "Accepted"
                                  ) +
                                  "\n        "
                              ),
                              _vm.$userIsManager
                                ? [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.talentAppliedForBooking) +
                                        ")"
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm.talentHasDeclinedBooking
                        ? _c(
                            "span",
                            { staticClass: "label label-danger" },
                            [
                              _vm._v("\n        Declined\n        "),
                              _vm.$userIsManager
                                ? [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.talentDeclinedBooking) +
                                        ")"
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm.talentHasMixedResponse
                        ? [
                            _c("span", { staticClass: "label label-success" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$declineModuleEnabled
                                    ? _vm.$t("Applied")
                                    : "Accepted"
                                ) +
                                  " (" +
                                  _vm._s(_vm.talentAppliedForBooking) +
                                  ")"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "label label-danger" }, [
                              _vm._v(
                                "Declined (" +
                                  _vm._s(_vm.talentDeclinedBooking) +
                                  ")"
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "title",
          fn: function () {
            return [
              _c("span", [_vm._v(_vm._s(_vm.bookingName))]),
              _vm._v(" "),
              _vm.$userIsAdmin
                ? _c("span", [
                    _vm._v(
                      " - " +
                        _vm._s(
                          _vm._f("date")(
                            _vm.bookingDateCreated,
                            _vm.$user.date_format_preference
                          )
                        )
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.bookingIsDraft
                ? _c("span", { staticClass: "small" }, [_vm._v("– (Draft)")])
                : _vm._e(),
              _vm._v(" "),
              _vm.bookingIsVetting
                ? _c("span", { staticClass: "small" }, [_vm._v("– (Pending)")])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        _vm.$userIsAdmin && _vm.bookingHasTalentResponses
          ? {
              key: "bids",
              fn: function () {
                return [
                  _c(
                    "span",
                    {
                      staticClass: "list-item__bids",
                      attrs: { "data-test-id": "numberBids" },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.booking.talent_response_count) +
                          "\n    "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "categories",
          fn: function () {
            return [
              _vm.booking.opportunities.length
                ? _c(
                    "div",
                    { staticClass: "flex flex-wrap" },
                    _vm._l(_vm.booking.opportunities, function (app) {
                      return _c(
                        "span",
                        { key: app.id, staticClass: "label label-info" },
                        [_vm._v(_vm._s(app.name))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "status",
          fn: function () {
            return [
              _c("div", { staticClass: "spacer-b-2" }, [
                _vm.bookingIsCancelled
                  ? _c("span", { staticClass: "label label-default" }, [
                      _vm._v("Cancelled"),
                    ])
                  : _vm.bookingIsWithdrawn
                  ? _c("span", { staticClass: "label label-info" }, [
                      _vm._v("Withdrawn"),
                    ])
                  : _vm.bookingIsDeclined
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Declined"),
                    ])
                  : _vm.bookingIsContextuallyUnsuccessful
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Unsuccessful"),
                    ])
                  : _vm.bookingIsCompleted
                  ? _c("span", { staticClass: "label label-success" }, [
                      _vm._v("Completed"),
                    ])
                  : _vm.bookingHasExpired
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Expired"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.booking.urgent
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Urgent"),
                    ])
                  : _vm._e(),
              ]),
            ]
          },
          proxy: true,
        },
        _vm.userCanSeeBudget
          ? {
              key: "hero",
              fn: function () {
                return [
                  _vm.$userIsTalent || _vm.$userIsManager
                    ? [
                        _vm.booking.local_currency
                          ? [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("abbreviatedCurrency")(
                                        _vm.booking
                                          .local_currency_budget_per_star_as_user_rate,
                                        _vm.booking.local_currency
                                      )
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("abbreviatedCurrency")(
                                        _vm.booking
                                          .budget_per_star_as_user_rate,
                                        _vm.booking.currency
                                      )
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ],
                      ]
                    : _vm.bookingGrandTotalBudget
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("nullable")(
                              _vm._f("abbreviatedCurrency")(
                                _vm.bookingGrandTotalBudget,
                                _vm.booking.local_currency
                                  ? _vm.booking.local_currency
                                  : _vm.booking.currency
                              )
                            )
                          )
                        ),
                      ])
                    : _c("span", [_vm._v("View")]),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "admin",
          fn: function () {
            return [
              _vm.booking.local_currency
                ? _c("div", { staticClass: "spacer-b-1 flex flex-row" }, [
                    _c("i", { staticClass: "fa fa-info-circle spacer-r-1" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Estimated conversion to " +
                          _vm._s(_vm.booking.local_currency) +
                          ". Actual amount may differ due to fluctuating conversion rates."
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.bookingIsNotPublic && _vm.$userIsAdmin
                ? _c("meta-item", { attrs: { icon: "eye-slash" } }, [
                    _vm._v("Hidden"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin
                ? _c(
                    "meta-item",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "key",
                            fn: function () {
                              return [_vm._v("Vetted:")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2728293474
                      ),
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm._f("date")(
                              _vm.bookingVettedDate,
                              _vm.$user.date_format_preference
                            )
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }